import { render, staticRenderFns } from "./Username.vue?vue&type=template&id=1ae1408f&scoped=true"
import script from "./Username.vue?vue&type=script&lang=js"
export * from "./Username.vue?vue&type=script&lang=js"
import style0 from "./Username.vue?vue&type=style&index=0&id=1ae1408f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1408f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae1408f')) {
      api.createRecord('1ae1408f', component.options)
    } else {
      api.reload('1ae1408f', component.options)
    }
    module.hot.accept("./Username.vue?vue&type=template&id=1ae1408f&scoped=true", function () {
      api.rerender('1ae1408f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/Username.vue"
export default component.exports